import axios from "axios";
import { endpoints } from "config/api";
import { getToken } from "./helpers/utilities";
import { axiosErrorHandler } from "./helpers/axiosHelpers";

//get personal details api
export const getPersonalDetailsApi = async () => {
  let request = await axios({
    method: "get",
    url: endpoints.profile.GET_PERSONAL_PROFILE,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

//get address details api
export const getAdderssDetailsApi = async () => {
  let request = await axios({
    method: "get",
    url: endpoints.profile.GET_ADDRESS_DETAIL,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

//get education details api
export const getEducationDetailsApi = async () => {
  let request = await axios({
    method: "get",
    url: endpoints.profile.GET_EDUCATION_DETAILS,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

//get payment details api
export const getPaymentDetailsApi = async () => {
  let request = await axios({
    method: "get",
    url: endpoints.profile.GET_PAYMENT_DETAILS,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

//update notificaton
export const updateNotificationApi = async (data) => {
  let request = await axios({
    method: "put",
    url: endpoints.profile.UPDATE_NOTIFICATION,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

//change password
export const changePasswordApi = async (data) => {
  let request = await axios({
    method: "put",
    url: endpoints.profile.CHANGE_PASSWORD,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

export const getUserStatus = async () => {
  const request = await axios({
    method: "get",
    url: endpoints.profile.GET_USER_STATUS,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  }).catch(axiosErrorHandler);
  return request;
};

export const getFamilyTree = (userId) => {
  let url = endpoints.profile.GET_FAMILY_TREE;
  if (userId) url = `${url}?userId=${userId}`;
  let request = axios({
    method: "get",
    url,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

//get family member
export const getFamilyMembersApi = (famId, userId) => {
  let request = axios({
    method: "get",
    url:
      endpoints.profile.GET_FAMILY_MEMBERS_BY_COND +
      `?famId=${famId}&userId=${userId}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

//get By mobile number
export const GetMemberMyNumber = (mobileNumber) => {
  let request = axios({
    method: "get",
    url: endpoints.profile.GET_MOBILENUMBER_MEMBER,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    params: mobileNumber,
  }).catch(axiosErrorHandler);
  return request;
};

export const addFamilyMemberApi = (data, id) => {
  console.log(id, "ididididi");
  return axios({
    method: "post",
    url: endpoints.profile.ADD_FAMILY_MEMBER,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data,
    params: id,
  }).catch(axiosErrorHandler);
};

export const getFamilyRelations = () => {
  let request = axios({
    method: "get",
    url: endpoints.profile.GET_FAMILY_RELATIONS,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

export const getHeaderUserDetail = () => {
  let request = axios({
    method: "get",
    url: endpoints.profile.HEADER_USER_DETAIL,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

export const updateFamilyMember = (data) => {
  let request = axios({
    method: "put",
    url: endpoints.profile.UPDATE_FAMILY_MEMBER,
    data,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

//upload reports api
export const uploadDocumentsApi = (formData) => {
  console.log(formData, "formData");
  let request = axios({
    method: "post",
    url: endpoints.profile.UPLOAD_IMAGES,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: formData,
  }).catch(axiosErrorHandler);
  return request;
};

export const getFamilyMember = (params) => {
  let url = endpoints.profile.GET_FAMILY_MEMBERS_BY_COND;
  // if (famId) url += `famId=${famId}`;
  // if (id) url += `id=${id}`;
  // if (userId) url += `&userId=${userId}`;
  let request = axios({
    method: "get",
    url,
    params: params,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

//get state and district by pincode
export const GetStateAndPincodeByApi = (pin) => {
  let request = axios({
    method: "get",
    url: `${endpoints.profile.GET_BY_PINCODE}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    params: pin,
  }).catch(axiosErrorHandler);
  return request;
};

//update patient profile
export const UpdatePatientProfile = (body) => {
  let request = axios({
    method: "post",
    url: `${endpoints.profile.EDIT_PATIENT_DETAIL}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: body,
  }).catch(axiosErrorHandler);
  return request;
};
